// Location API
import {
    RequestConfigFunction, SelectorConfig, UseRequestConfig,
} from 'app/types/request.types'

import {
    Location,
} from 'app/Apps/ContactManagement/Locations/Locations.types'

type LocationRequests = {
    domainName: string,
    get: RequestConfigFunction<{id: number}>,
    skyMindSyncUpdate: RequestConfigFunction<{id: number}>,
    archive: RequestConfigFunction<{id: number}>,
    restore: RequestConfigFunction<{id: number}>,
    locationDuplicateCheck: RequestConfigFunction<
        { data: { longitude: number, latitude: number } }>,
    create: RequestConfigFunction<{ data: Location }>,
    update: RequestConfigFunction<{ data: Location }>,
    all: RequestConfigFunction<{params?: Record<string, string>}>,
    multiByIds: RequestConfigFunction<{ ids: number[] }>,
    filter: {
        isProspect: boolean[]
    },
    filterRequest: UseRequestConfig,
    selector: SelectorConfig<undefined>,
    createArea: RequestConfigFunction<{locationId: number}>,
    getAreasByLocation: RequestConfigFunction<{id: number, params?: Record<string, string>}>,
    modifications: (number) => {
        customUrl: string,
        method: string,
        name: string,
    },
}

const locationRequests: LocationRequests = {
    domainName: 'Location',
    get: ({
        id,
    }) => {
        return {
            url: `location/${id}`,
            method: 'GET',
        }
    },
    skyMindSyncUpdate: ({
        id,
    }) => {
        return {
            url: `location/${id}/skymind-sync`,
            method: 'PATCH',
        }
    },
    archive: ({
        id,
    }) => {
        return {
            url: `location/${id}/archive`,
            method: 'PATCH',
        }
    },
    restore: ({
        id,
    }) => {
        return {
            url: `location/${id}/restore`,
            method: 'PATCH',
        }
    },
    locationDuplicateCheck: ({
        data,
    }) => {
        return {
            url: 'location/duplicate-check',
            method: 'POST',
            data,
        }
    },
    create: ({
        data,
    }) => {
        return {
            url: 'location',
            method: 'POST',
            data,
        }
    },
    update: ({
        data,
    }) => {
        return {
            url: `location/${data?.id}`,
            method: 'PUT',
            data,
        }
    },
    all: ({
        params = {},
    } = {}) => {
        return {
            url: 'location/filter-request/all',
            method: 'POST',
            ...params,
        }
    },
    multiByIds: ({
        ids,
    }) => {
        return {
            url: 'location/filter-request/all',
            method: 'POST',
            data: {
                includeFilters: {
                    id: ids,
                },
            },
        }
    },
    filter: {
        isProspect: [
            true,
            false,
        ],
    },
    filterRequest: {
        requestFn: (params) => {
            return {
                url: 'location/filter-request/all',
                method: 'POST',
                data: {
                    ...params,
                    rows: 50,
                },
            }
        },
    },
    selector: {
        url: 'location/filter-request/all',
    },
    createArea: ({
        locationId,
    }) => {
        return {
            url: `location/${locationId}/area`,
            method: 'POST',
        }
    },
    getAreasByLocation: ({
        id,
        params,
    }) => {
        return {
            url: `location/${id}/area/filter-request/all`,
            method: 'POST',
            ...params,
        }
    },
    modifications: (locationNumber) => {
        return {
            customUrl: `location/${locationNumber}/modifications`,
            method: 'GET',
            name: 'Location',
        }
    },
}

export default locationRequests
